// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3jGXv","title":"FrontImage_title__3RM30"};